export default __webpack_public_path__ + "lite-ocrbd5d17.jpg";